<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
                .form__field-body
                    cs-multiselect(
                        :options="allowedDifficulties"
                        v-model="params.difficult"
                        :placeholder="tableLabel(params.difficult)"
                        :custom-label="tableLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}
                .form__field-body
                    cs-multiselect(
                        :options="operations"
                        v-model="params.operations"
                        :placeholder="operationsLabel(params.operations)"
                        :custom-label="operationsLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
                span.help.is-danger(v-show="errors.has('operations')")
                    |  {{  $i18n.t('trainer.trainer_gameFormErrors_chooseOperation')  }}
            divider
            .row
                .col-md-9.col-xs-12
                    .divisible-multiplier
                        span
                            template(v-if='params.numbers.length  ===  0')
                                |   {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')  }}
                            template(v-else='')
                                |   {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}
                    .form__field_columns.form__field_numbers
                        template(v-for='(number, index) in numbers')
                            cs-checkbox.checkbox-for-numbers(
                                :checked="params.numbers && params.numbers.includes(number)",
                                @change="setNumber(number)"
                                :disabled="params.operations.divide && number === 0"
                            )
                                |   {{ number }}
                    span.help.is-danger(v-show="errors.has('numbers')")
                        |  {{  $i18n.t('trainer.trainer_gameFormSetting_select')  }}
                        template(v-if='params.numbers.length  ===  0')
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')  }}
                        template(v-else)
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier')  }}
            slot(name='parameters')
            .help-text
                slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode' :disabled="isSaveButtonDisabled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame' :disabled="isSaveButtonDisabled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame' :disabled="isSaveButtonDisabled")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from '@/utils/trainer/getInitParameters';
    import { mapState } from 'vuex';
    import { cloneDeep } from 'lodash';
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';

    export default {
        props: {
            slug: String,
            courseType: String,
            id: [Number, String],
            usersIds: [Array, String],
            homeworkId: [Number, String],
            gameMode: String,
            gameId: [Number, String],
            generatorGameIndex: Number,
            generatorSettings: Boolean,
            levelAnswerDuration: Number,
        },
        mixins: [GameFormMixin, multiplayerFormMixin],
        data() {
            return {
                selectedGroups: null,
                params: null,
                difficulties: [
                    {
                        amountOfRows: 4,
                        amountOfColumns: 3,
                    },
                    {
                        amountOfRows: 4,
                        amountOfColumns: 4,
                    },
                    {
                        amountOfRows: 4,
                        amountOfColumns: 5,
                    },
                    {
                        amountOfRows: 4,
                        amountOfColumns: 6,
                    },
                    {
                        amountOfRows: 5,
                        amountOfColumns: 6,
                    },
                    {
                        amountOfRows: 6,
                        amountOfColumns: 6,
                    },
                ],
                operations: [
                    {
                        divide: false,
                        multiply: true,
                    },
                    {
                        divide: true,
                        multiply: false,
                    },
                ],
                topicGroups: [],
                wordGroups: [],
                imageGroups: [],
            };
        },
        async mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray?.[0]?.slug === this.slug) {
                    this.paramsArray = cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(
                        this,
                        'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                } else {
                    this.params = cloneDeep(TrainerGames.games).find(
                        item => item.slug === this.slug
                    ).parameters.default;
                }
                this.params.courseType = 'multiplication';
            } else {
                this.setInitParams(this.getKey(this.usersIds));
                this.params.courseType = 'multiplication';
            }
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            allowedDifficulties() {
                if (this.params.numbers.length < 2) {
                    return this.difficulties.slice(0, -3);
                }
                return this.difficulties;
            },
            numbers() {
                return Array.from(Array(11), (_, i) => i);
            },
            topics() {
                let groups = this.imageGroups;
                groups = groups.map(topic => {
                    return { name: this.$i18n.t('trainer.trainer_gameFormSettingValue_' + topic), mode: topic };
                });
                return groups.sort((a, b) => a.name.localeCompare(b.name));
            },
            isSaveButtonDisabled() {
                return !this.params.numbers.length;
            },
        },
        watch: {
            'params.numbers'(val) {
                if (val.length) {
                    this.$validator.detach('numbers');
                } else {
                    this.$validator.attach('numbers', 'required');
                }
            },
            'params.numbers.length'(val) {
                if (val < 2) {
                    this.params.difficult = this.difficulties[0];
                }
            },
            'params.operations.divide'(val) {
                if (val) {
                    const indexOfZero = this.params.numbers.findIndex(number => number === 0);
                    if (indexOfZero) {
                        this.params.numbers.splice(1, indexOfZero);
                    }
                }
            },
        },
        methods: {
            setNumber(number) {
                if (this.params.numbers.includes(number)) {
                    this.params.numbers.splice(this.params.numbers.indexOf(number), 1);
                } else {
                    this.params.numbers.push(number);
                }
            },
            tableLabel(difficult) {
                return difficult.amountOfRows + ' x ' + difficult.amountOfColumns;
            },
            operationsLabel(operations) {
                if (operations.multiply) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_operationMultiply');
                }

                return this.$i18n.t('trainer.trainer_gameFormSetting_operationDivide');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field-body--inline {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .form__multiselect-container {
        flex: 1 1 auto;
    }

    .form__multiselect-container:not(:last-child) {
        margin-right: 10px;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
    .help-text {
        text-align: center;
    }

    .form__field_columns {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
    }

    .form__field_numbers {
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        margin-bottom: 0;
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field_operations {
        display: flex;
        @media screen and (max-width: 767px) {
            :first-child {
                flex-grow: 0;
                margin-right: 10px;
            }
        }
        @include media($md) {
            display: block;
        }
    }

    .checkbox-for-numbers {
        margin-right: 15px;
        margin-bottom: $space-small !important;
    }

    .divisible-multiplier {
        margin: 10px 5px;
    }

    .multiplication-division {
        @include stack-space($space-small);
    }
</style>
